/* global gsap */
/**
 * Sonar animation
 * @param {Element} element - element to animate
 */
function sonarAnimation(element) {
  const centerCircle = element.querySelector('.center-circle');
  const ellipse = element.querySelectorAll('.ellipse');
  const line = element.querySelectorAll('.line');
  const topCircle = element.querySelectorAll('.top-circle');
  const bottomCircle = element.querySelectorAll('.bottom-circle');

  const tl = gsap.timeline({
    id: 'master',
    yoyo: true,
    repeat: -1,
    repeatDelay: 0.5,
    timeScale: 3,
  });

  tl.from(centerCircle, {
    duration: 0.25,
    opacity: 0,
    scale: 0.25,
    transformOrigin: 'center center',
  }).from(ellipse, {
    duration: 0.35,
    opacity: 0,
    scale: 0.85,
    ease: 'power4.out',
    transformOrigin: 'center center',
    stagger: 0.2,
  }, '<').from(line, {
    duration: 0.75,
    drawSVG: 0,
    ease: 'none',
    stagger: 0.2,
  }, '<15%').from(topCircle, {
    duration: 0.15,
    opacity: 0,
    scale: 0.25,
    transformOrigin: 'center center',
    stagger: 0.3,
  }, '<+=0.5').from(bottomCircle, {
    duration: 0.15,
    opacity: 0,
    scale: 0.25,
    transformOrigin: 'center center',
    stagger: 0.3,
  }, '<+=0.3');
}

export {sonarAnimation};
